import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "submit", "spinner", "text"];
  static values = { text: String };

  connect() {
    // Store original text for each text target
    if (this.hasTextTarget) {
      this.originalText = this.textTargets.map(target => target.textContent.trim());
    }

    // Bind event handlers
    this.onStart = this.onStart.bind(this);
    this.onFetchResponse = this.onFetchResponse.bind(this);
    this.onSubmitEnd = this.onSubmitEnd.bind(this);

    // Listen for Turbo form events
    this.formTarget.addEventListener("turbo:submit-start", this.onStart);
    this.formTarget.addEventListener("turbo:before-fetch-response", this.onFetchResponse);
    this.formTarget.addEventListener("turbo:submit-end", this.onSubmitEnd);
  }

  disconnect() {
    // Clean up event listeners
    this.formTarget.removeEventListener("turbo:submit-start", this.onStart);
    this.formTarget.removeEventListener("turbo:before-fetch-response", this.onFetchResponse);
    this.formTarget.removeEventListener("turbo:submit-end", this.onSubmitEnd);
  }

  onStart() {
    this.lock();
  }

  onFetchResponse(e) {
    // Unlock if response is not OK (>=400)
    const ok = e.detail.fetchResponse.response.ok;
    if (!ok) this.unlock();
    // If OK, the frame/page will replace; no need to unlock
  }

  onSubmitEnd(e) {
    // Unlock on any submission failure
    if (e.detail.success === false) this.unlock();
  }

  lock() {
    this.submitTargets.forEach(btn => {
      btn.setAttribute("disabled", "disabled");
      btn.setAttribute("aria-busy", "true");
      btn.classList.add(
        "cursor-not-allowed",
        "opacity-50",
        "hover:bg-black" 
      );
      btn.style.filter = "brightness(95%)";
    });

    // Show spinner
    if (this.hasSpinnerTarget) {
      this.spinnerTargets.forEach(spinner => {
        spinner.classList.remove("hidden");
      });
    }

    // Update button text
    if (this.hasTextTarget && this.hasTextValue) {
      this.textTargets.forEach(target => {
        target.textContent = this.textValue || "Please wait";
      });
    }
  }

  unlock() {
    this.submitTargets.forEach(btn => {
      btn.removeAttribute("disabled");
      btn.removeAttribute("aria-busy");
      btn.classList.remove("cursor-not-allowed");
      btn.style.filter = "";
    });

    // Hide spinner
    if (this.hasSpinnerTarget) {
      this.spinnerTargets.forEach(spinner => {
        spinner.classList.add("hidden");
      });
    }

    // Restore original button text
    if (this.hasTextTarget && this.originalText) {
      this.textTargets.forEach((target, index) => {
        target.textContent = this.originalText[index] || "";
      });
    }
  }
}